<template>
<div>
  <el-dialog :visible.sync="visible" title="选择授权人" :width="'800px'">
    <div class="view-filter">
      <el-form :inline="true" :model="filterForm" size="small" label-suffix=":">
        <el-form-item label="">
          <el-input v-model="filterForm.find_value" placeholder="请输入姓名/手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="onSearch">查找</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <div class="box left">
        <div class="header">选择：{{ left.length }}</div>
        <div class="list-body">
          <ul class="list-content">
            <li class="list-item header">
              <span class="content">授权人姓名</span>
              <span class="content">手机号</span>
            </li>
            <li
              class="list-item"
              v-for="item in left"
              :key="item.user_id"
              @click="leftSelect(item.user_id)"
            >
              <span class="content">{{ item.user_name }}</span>
              <span class="content">{{ item.phone }}</span>
            </li>
          </ul>
        </div>
      </div>
<!--      ***-->
      <div class="box middle">
        <el-button
          type="primary"
          :style="buttonStyle"
          :size="'small'"
          @click="selectAll"
        >
          全选
          <i class="el-icon-arrow-right"></i>
        </el-button>
        <el-button
          type="primary"
          :style="buttonStyle"
          :size="'small'"
          @click="removeAll"
        >
          <i class="el-icon-arrow-left"></i>
          移除
        </el-button>
      </div>
      <div class="box right">
        <div class="header">已选：{{ right.length }}</div>
        <div class="list-body">
          <ul class="list-content">
            <li class="list-item header">
              <span class="content">授权人姓名</span>
              <span class="content">手机号</span>
            </li>
            <li
              class="list-item"
              v-for="item in right"
              :key="item.user_id"
              @click="rightDelete(item.user_id)"
            >
              <span class="content">{{ item.user_name }}</span>
              <span class="content">{{ item.phone }}</span>
              <i class="icon-close el-icon-close"></i>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
    <el-button @click="visible = false">取 消</el-button>
    <el-button type="primary" @click="save">确 定</el-button>
  </span>
  </el-dialog>
</div>
</template>

<script>
import { empowerList } from '../api';

export default {
  name: 'SelectEmpowerDialog',
  data() {
    return {
      visible: false,
      filterForm: {
        find_value: '',
      },
      left: [],
      right: [],
      buttonStyle: {
        display: 'block',
        marginBottom: '4px',
        marginLeft: '0',
      },
    };
  },
  mounted() {
    this._getList();
  },
  methods: {
    _getList() {
      const filterForm = { ...this.filterForm };
      filterForm.page = -1;
      empowerList(filterForm).then((res) => {
        if (res.status === 0) {
          const { data } = res;
          this.left = data;
          this.listData = [...data];
        } else {
          this.left = [];
        }
      });
    },
    leftSelect(id) {
      const { left } = this;
      const target = left.filter(item => item.user_id === id)[0];
      this.right.push(target);
      this.left = left.filter(item => item.user_id !== id);
    },
    rightDelete(id) {
      const { right } = this;
      const target = right.filter(item => item.user_id === id)[0];
      this.left.push(target);
      this.right = right.filter(item => item.user_id !== id);
    },
    selectAll() {
      this.left = [];
      this.right = [...this.listData];
    },
    removeAll() {
      this.left = [...this.listData];
      this.right = [];
    },
    openDialog(targetKeys) {
      const { listData } = this;
      this.right = listData.filter(
        item => targetKeys.indexOf(item.user_id) > -1,
      );
      this.left = listData.filter(
        item => targetKeys.indexOf(item.user_id) === -1,
      );
      this.visible = true;
    },
    onSearch() {
      this._getList();
    },
    save() {
      this.$emit('save', [...this.right]);
      this.visible = false;
    },
  },
};
</script>

<style scoped lang="scss">
  .icon-close {
    position: absolute;
    right: 9px;
    top: 9px;
    cursor: pointer;
    &:hover {
      color: #000;
    }
  }
  .box {
    display: inline-block;
    vertical-align: middle;
    &.left,
    &.right {
      position: relative;
      padding-top: 34px;
      width: 330px;
      height: 400px;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      .header {
        padding: 6px 12px;
        border-radius: 4px 4px 0 0;
        background: #fff;
        color: rgba(0, 0, 0, 0.65);
        border-bottom: 1px solid #e8e8e8;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
      }
      .list-body {
        position: relative;
        height: 100%;
        font-size: 14px;
        .list-content {
          height: 100%;
          overflow: auto;
          list-style: none;
          padding: 0;
          margin: 0;
          .list-item {
            position: relative;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding: 0 32px 0 12px;
            min-height: 32px;
            -webkit-transition: all 0.3s;
            transition: all 0.3s;
            list-style: none;
            &:hover:not(.header) {
              background-color: #e6f7ff;
            }
          }
        }
      }
    }
    &.left {
      .list-item {
        cursor: pointer;
      }
    }
    &.middle {
      overflow: hidden;
      margin: 0 8px;
    }
  }
  .list-item{
    .content{
      display:inline-block;
      padding: 5px;
      width:42%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
    }
    &.header{
      background: #fafafa !important;
      .content{
        background: #fafafa;
      }
    }
  }
  .view-filter{
    padding-left: 0;
  }
</style>
